<template>
  <ProductSerialNumber :product-serial-number-id="$route.params.id" />
</template>
<script>
import ProductSerialNumber from "@/gapp-components/components/views/promotions/ProductSerialNumber.vue";

export default {
  name: "SerialNumbersPage",
  metaInfo: {
    title: "VINs"
  },
  components: {
    ProductSerialNumber
  }
};
</script>
